import Events from '@utilities/events';
import RafThrottle from '@utilities/raf-throttle';
import ScreenDimensions from '@utilities/screen-dimensions';

class ShowRefinementFilters {
  constructor(element) {
    this.element = element;
    this.id = element.getAttribute('aria-controls');
    this.bindEvents();
  }

  static closeRefinementFilters() {
    if (ScreenDimensions.isTabletPortraitAndBigger) {
      Events.$trigger(`modal[refinement-bar]::close`, { data: { retainTabIndex: true } });
    }
  }

  /**
   * Bind all general events
   */
  bindEvents() {
    RafThrottle.set([
      {
        element: window,
        event: 'resize',
        namespace: `RefinementsResize-${this.id}`,
        fn: () => ShowRefinementFilters.closeRefinementFilters(),
        delay: 250,
      },
    ]);
  }
}

export default ShowRefinementFilters;
